import $ from 'jquery';
import _ from 'underscore';
import ReactDOM from 'react-dom';

function replaceToken(pattern, val, str) {
  const regexp = new RegExp(pattern);
  let finalString = str;
  while (regexp.test(finalString)) {
    finalString = finalString.replace(pattern, val);
  }

  return finalString;
}

export function replaceCurly(str, ctx, args) {
  const cidpattern = /{cid}/;
  const uidpattern = /{uid}/;
  const aidpattern = /{aid}/;
  const cmpidpattern = /{cmpid}/;
  const adgidpattern = /{adgid}/;
  let finalStr = str;
  let argCounter = 0;
  let params = args;

  if (!str) {
    return null;
  }

  if (!Array.isArray(args)) {
    params = [args];
  }

  if (ctx) {
    const userId = ctx.CurrentUser ? ctx.CurrentUser.Id : ctx.UserId;

    finalStr = replaceToken(cidpattern, ctx.CustomerId, finalStr);
    finalStr = replaceToken(uidpattern, userId, finalStr);
    finalStr = replaceToken(aidpattern, ctx.AccountId, finalStr);
    if (ctx.CampaignId) {
      finalStr = replaceToken(cmpidpattern, ctx.CampaignId, finalStr);
    }
    if (ctx.AdGroupId) {
      finalStr = replaceToken(adgidpattern, ctx.AdGroupId, finalStr);
    }
  }

  while (finalStr.indexOf(`{${argCounter}}`) > -1 && argCounter < args.length) {
    if (typeof (params[argCounter]) === 'string') {
      finalStr = finalStr.replace(`{${argCounter}}`, params[argCounter]);
    }
    argCounter += 1;
  }
  return finalStr;
}

export const insightPopupContainerId = 'insight-popup-placeholder';

// Insert a placeholder for popover when rendering popup in Backbone view.
export const insertPopoverContainer = (placeHolderId = insightPopupContainerId) => {
  // insert a static div for rendering element
  if ($(`#${placeHolderId}`).length === 0) {
    $('<div/>').attr('id', placeHolderId).appendTo(document.body);
  }
};

export const getDefaultFeedbackOptions = i18n => [
  {
    key: '0',
    text: i18n.getString('Fluctuation_Feedback1'),
    name: 'feedback1',
  }, {
    key: '1',
    text: i18n.getString('Fluctuation_Feedback2'),
    name: 'feedback2',
  }, {
    key: '2',
    text: i18n.getString('Fluctuation_Feedback3'),
    name: 'feedback3',
  }];

export const getDefaultDismissOptions = i18n => [
  {
    key: '0',
    text: i18n.getString('Fluctuation_Dismiss_Feedback1'),
    name: 'dismiss1',
  }, {
    key: '1',
    text: i18n.getString('Fluctuation_Dismiss_Feedback2'),
    name: 'dismiss2',
  }, {
    key: '2',
    text: i18n.getString('Fluctuation_Dismiss_Feedback3'),
    name: 'dismiss3',
  }];

export function dismissPopupIfExist(popupContainers, popupClassName = 'bingads-fluctuation-wrapper') {
  /* istanbul ignore next */
  const showPopup = document.getElementsByClassName(popupClassName).length > 0;
  /* istanbul ignore next */
  if (showPopup && popupContainers.length) {
    _.each(popupContainers, container => container && ReactDOM.unmountComponentAtNode(container));
  }
}
